import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	emptyFirstSprintTitle: {
		id: 'backlog.card-list.first-sprint-blank-state.empty-first-sprint-title',
		defaultMessage: 'Plan your sprint',
		description: 'Title of empty sprint area on backlog page',
	},
	emptyFirstSprintDescription: {
		id: 'backlog.card-list.first-sprint-blank-state.empty-first-sprint-description',
		defaultMessage:
			"Drag issues from the {backlog} section, or create new issues, to plan the work for this sprint. Select {startSprint} when you're ready.",
		description:
			'Description attached to empty sprint area on backlog page explaining how to add work to sprint',
	},
	backlog: {
		id: 'backlog.card-list.first-sprint-blank-state.backlog',
		defaultMessage: 'Backlog',
		description: 'The word "Backlog" is to be made bold in emptyFirstSprintDescription',
	},
	startSprint: {
		id: 'backlog.card-list.first-sprint-blank-state.start-sprint',
		defaultMessage: 'Start sprint',
		description: 'The words "Start sprint" is to be made bold in emptyFirstSprintDescription',
	},
	emptyFirstSprintDescriptionIssueTermRefresh: {
		id: 'backlog.card-list.first-sprint-blank-state.empty-first-sprint-description-issue-term-refresh',
		defaultMessage:
			"Drag issues from the {backlog} section, or create new issues, to plan the work for this sprint. Select {startSprint} when you're ready.",
		description:
			'Description attached to empty sprint area on backlog page explaining how to add work to sprint',
	},
});
